module.exports = __webpack_public_path__ + "static/media/tokyo.540a1749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightBrowse/img/destinations/tokyo.jpg
// module id = 1035
// module chunks = 0